/**
 * Utility functions for country-related checks
 */

/**
 * Checks if the current user is from the United States, India, or Canada
 * @returns true if user's country is "United States", false otherwise
 */
export const isUSUser = (): boolean => {
  const country = localStorage.getItem("country") ?? "";
  if (country === "United States" || country === "India" || country === "Canada") {
    return true;
  }
  return false;
};

/**
 * Gets the user's country from localStorage
 * @returns user's country or empty string if not set
 */
export const getUserCountry = (): string => {
  return localStorage.getItem("country") ?? "";
};
